import Vue from 'vue';

export default class PageHeader {
    constructor(){
        this.data = Vue.observable({ show:true });
    }

    state() {
        return this.data.show;
    }

    show() {
        this.data.show = true;
    }

    hide() {
        this.data.show = false;
    }
}
